import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { useState } from 'react'
import { KTSVG, toAbsoluteUrl, resolveCompanyLogoUrl } from '../../../helpers'
import { useLayout } from '../../core'
import * as authHelper from '../../../../app/modules/auth/core/AuthHelpers'

const SidebarLogo = () => {
  const { config } = useLayout()
  const auth = authHelper.getAuth()
  const companyLogoUrl = resolveCompanyLogoUrl(auth?.result?.companyLogo)
  const defaultLogoUrl = toAbsoluteUrl('/media/logos/aisenseus-logo-21-landscape-white.webp')
  const [logoUrl, setLogoUrl] = useState(companyLogoUrl)
  const hasCustomCompanyLogo =
    logoUrl !== defaultLogoUrl && auth?.result?.companyLogo != null && auth.result.companyLogo.trim() !== ''
  const logoHeightClass = hasCustomCompanyLogo ? '60' : '40'

  const handleLogoError = () => {
    if (logoUrl !== defaultLogoUrl) {
      setLogoUrl(defaultLogoUrl)
    }
  }
  const appSidebarDefaultMinimizeDesktopEnabled =
    config?.app?.sidebar?.default?.minimize?.desktop?.enabled
  const appSidebarDefaultCollapseDesktopEnabled =
    config?.app?.sidebar?.default?.collapse?.desktop?.enabled
  const toggleType = appSidebarDefaultCollapseDesktopEnabled
    ? 'collapse'
    : appSidebarDefaultMinimizeDesktopEnabled
      ? 'minimize'
      : ''
  const toggleState = appSidebarDefaultMinimizeDesktopEnabled ? 'active' : ''
  const appSidebarDefaultMinimizeDefault = config.app?.sidebar?.default?.minimize?.desktop?.default
  return (
    <div className='app-sidebar-logo px-6' id='kt_app_sidebar_logo'>
      <Link to='/dashboard'>
        {config.layoutType === 'dark-sidebar' ? (
          <img
            alt='Logo'
            src={logoUrl}
            onError={handleLogoError}
            className={`h-${logoHeightClass}px app-sidebar-logo-default`}
          />
        ) : (
          <>
            <img
              alt='Logo'
              src={logoUrl}
            onError={handleLogoError}
              className={`h-${logoHeightClass}px app-sidebar-logo-default theme-light-show`}
            />
            <img
              alt='Logo'
              src={logoUrl}
            onError={handleLogoError}
              className={`h-${logoHeightClass}px app-sidebar-logo-default theme-dark-show`}
            />
          </>
        )}

        <img
          alt='Logo'
          src={logoUrl}
          onError={handleLogoError}
          className={`h-${logoHeightClass}px a app-sidebar-logo-minimize`}
        />
      </Link>

      {(appSidebarDefaultMinimizeDesktopEnabled || appSidebarDefaultCollapseDesktopEnabled) && (
        <div
          id='kt_app_sidebar_toggle'
          className={clsx(
            'app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate',
            { active: appSidebarDefaultMinimizeDefault }
          )}
          style={{ maxHeight: "30px" }}
          data-kt-toggle='true'
          data-kt-toggle-state={toggleState}
          data-kt-toggle-target='body'
          data-kt-toggle-name={`app-sidebar-${toggleType}`}
        >
          <KTSVG path='/media/icons/duotune/arrows/arr079.svg' className='svg-icon-2 rotate-180' />
        </div>
      )}
    </div>
  )
}

export { SidebarLogo }
